import TemaDetalleView from "../../components/tema/TemaDetalleView";

/** Ficha de un tema dentro de la app (`/app/temas/:id`). */
export default function TemaDetalle() {
  return <TemaDetalleView />;
}
